import { AbstractPmsApiService } from "./abstract.service";
import { Property, PaymentDetail } from "../models";

/**
 * @class PaymentDetailPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<PaymentDetail>}
 */
export class PaymentDetailPmsApiService extends AbstractPmsApiService {
    
    get urlPattern() {
        
        return '/billing/property/:propertyId/subscription/payment-detail(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {PaymentDetail}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new PaymentDetail(attributes);
    }
    
    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<PaymentDetail>>}
     */
    get (params = {}) {

        const url = this.url({propertyId: 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Property} property
     * @param {PaymentDetail} paymentDetail
     * @returns {Promise.<PaymentDetail>}
     */
    update(property, paymentDetail) {
        
        const url = this.url({
            propertyId: property.id,
            id: paymentDetail.id
        });
        
        const payload = paymentDetail.toObject();
        
        if (payload.paymentMethod) {
            
            payload.type = payload.paymentMethod;
            
            delete payload.paymentMethod;
        }
        
        return this.http
            .put(url, payload, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/payment-detail.service.js